import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded'
import HandymanRoundedIcon from '@mui/icons-material/HandymanRounded'
import LayersRoundedIcon from '@mui/icons-material/LayersRounded'
import PrecisionManufacturingRoundedIcon from '@mui/icons-material/PrecisionManufacturingRounded'
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded'
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded'
import ViewInArRoundedIcon from '@mui/icons-material/ViewInArRounded'
import { wireEntityType } from './qrEntityTypes'

/**
 * A silhouette per entity type a MIC label can carry.
 *
 * Six types are read on the same card and the word alone is the slowest way to tell them apart: an
 * operator glancing at a screen recognises the shape of a work order against the shape of a tool
 * before reading either. The pairs are the plainest reading of each type — a machine for a part being
 * made, layers for material in stock, a work sheet for a fabrication order, a receipt with lines for a
 * customer order, tools for a tool, a frame for the fixture that holds a part.
 *
 * Kept out of qrEntityTypes on purpose: that module is a zero-import leaf read by pure mapping code and
 * by the API layer, and an icon is UI.
 */
const ENTITY_ICONS = {
  PART: PrecisionManufacturingRoundedIcon,
  RAWMATERIAL: LayersRoundedIcon,
  FABRICATIONORDER: AssignmentRoundedIcon,
  ORDER: ReceiptLongRoundedIcon,
  TOOL: HandymanRoundedIcon,
  FIXTURE: ViewInArRoundedIcon
}

/**
 * @param {string} entityType in either form
 * @returns {import('react').ComponentType} a type this front does not know falls back to the QR itself,
 *   which is the one thing still true about it.
 */
export const entityTypeIcon = (entityType) => ENTITY_ICONS[wireEntityType(entityType)] || QrCode2RoundedIcon
